import React from 'react'
import { flexRender } from '@tanstack/react-table'

export const TenantMembersTableComponent = ({ table }) => {
  const rows = table.getRowModel().rows

  return (
    <div className="tenant-members">
      <div className="tenant-members__body wb-margin-top-xs">
        <table className="wb-table wb-table--border-horizontal tenant-members__body-table">
          <thead>
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => {
                  return (
                    <th key={header.id} colSpan={header.colSpan}>
                      {header.isPlaceholder ? null : (
                        <>
                          {flexRender(
                            header.column.columnDef.header,
                            header.getContext(),
                          )}
                          {header.column.getCanFilter() ? <div></div> : null}
                        </>
                      )}
                    </th>
                  )
                })}
              </tr>
            ))}
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td colSpan="7">
                  <p
                    className="wb-type-heading-m"
                    style={{ textAlign: 'center', padding: '3rem 0' }}
                  >
                    No expiring members found for selected tenant.
                  </p>
                </td>
              </tr>
            ) : (
              rows.map((row) => (
                <tr key={row.id}>
                  {row.getVisibleCells().map((cell) => (
                    <td key={cell.id}>
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext(),
                      )}
                    </td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      <div className="tenant-members__footer"></div>
    </div>
  )
}
